import { createSlice } from '@reduxjs/toolkit';
import {
	getGuidesInfoByCategory,
	getGuidesInfoByType,
	getGuidesInfoByStatus,
	getGuidesInfoByEstablishmenteType,
	getCategoryByYear,
	getResidueManagement,
	getGuidesInfoCompareType,
	getGuidesInfoCompareStatus,
	getGuidesInfoByFinalDestination,
	getGuidesInfoCompareManagement,
	getPointEstablishmentResidue
} from '../residueDashboard/thunk';

export const initialState = {
	infoCategory: [],
	infoType: [],
	infoStatus: [],
	infoEstablishmentType: [],
	infoCategoryByYear: [],
	infoResidueManagement: [],
	infoCompareType: [],
	infoCompareStatus: [],
	infoFinalDestination: [],
	infoCompareManagement: [],
	infoPointEstablishment: [],

	isLoading: false,
	isSuccess: false,
	isError: false,
	error: ""
};

const ResidueDashboardSlice = createSlice({
	name: 'ResidueDashboard',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getGuidesInfoByCategory.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isSuccess = true;
			state.infoCategory = action.payload;
		});
		builder.addCase(getGuidesInfoByCategory.pending, state => {
			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});
		builder.addCase(getGuidesInfoByCategory.rejected, (state, action) => {
			state.isLoading = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.error.message;
		});

		builder.addCase(getGuidesInfoByType.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isSuccess = true;
			state.infoType = action.payload;
		});
		builder.addCase(getGuidesInfoByType.pending, state => {
			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});
		builder.addCase(getGuidesInfoByType.rejected, (state, action) => {
			state.isLoading = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.error.message;
		});

		builder.addCase(getGuidesInfoByStatus.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isSuccess = true;
			state.infoStatus = action.payload;
		});
		builder.addCase(getGuidesInfoByStatus.pending, state => {
			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});
		builder.addCase(getGuidesInfoByStatus.rejected, (state, action) => {
			state.isLoading = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.error.message;
		});

		builder.addCase(getGuidesInfoByEstablishmenteType.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isSuccess = true;
			state.infoEstablishmentType = action.payload;
		});
		builder.addCase(getGuidesInfoByEstablishmenteType.pending, state => {
			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});
		builder.addCase(getGuidesInfoByEstablishmenteType.rejected, (state, action) => {
			state.isLoading = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.error.message;
		});

		builder.addCase(getCategoryByYear.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isSuccess = true;
			state.infoCategoryByYear = action.payload;
		});
		builder.addCase(getCategoryByYear.pending, state => {
			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});
		builder.addCase(getCategoryByYear.rejected, (state, action) => {
			state.isLoading = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.error.message;
		});

		builder.addCase(getResidueManagement.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isSuccess = true;
			state.infoResidueManagement = action.payload;
		});
		builder.addCase(getResidueManagement.pending, state => {
			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});
		builder.addCase(getResidueManagement.rejected, (state, action) => {
			state.isLoading = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.error.message;
		});


		builder.addCase(getGuidesInfoCompareType.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isSuccess = true;
			state.infoCompareType = action.payload;
		});
		builder.addCase(getGuidesInfoCompareType.pending, state => {
			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});
		builder.addCase(getGuidesInfoCompareType.rejected, (state, action) => {
			state.isLoading = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.error.message;
		});


		builder.addCase(getGuidesInfoByFinalDestination.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isSuccess = true;
			state.infoFinalDestination = action.payload;
		});
		builder.addCase(getGuidesInfoByFinalDestination.pending, state => {
			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});
		builder.addCase(getGuidesInfoByFinalDestination.rejected, (state, action) => {
			state.isLoading = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.error.message;
		});


		builder.addCase(getGuidesInfoCompareStatus.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isSuccess = true;
			state.infoCompareStatus = action.payload;
		});
		builder.addCase(getGuidesInfoCompareStatus.pending, state => {
			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});
		builder.addCase(getGuidesInfoCompareStatus.rejected, (state, action) => {
			state.isLoading = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.error.message;
		});


		builder.addCase(getGuidesInfoCompareManagement.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isSuccess = true;
			state.infoCompareManagement = action.payload;
		});
		builder.addCase(getGuidesInfoCompareManagement.pending, state => {
			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});
		builder.addCase(getGuidesInfoCompareManagement.rejected, (state, action) => {
			state.isLoading = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.error.message;
		});


		builder.addCase(getPointEstablishmentResidue.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isSuccess = true;
			state.infoPointEstablishment = action.payload;
		});
		builder.addCase(getPointEstablishmentResidue.pending, state => {
			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});
		builder.addCase(getPointEstablishmentResidue.rejected, (state, action) => {
			state.isLoading = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.error.message;
		});

	},
});

export const { setRequireCloseModal } = ResidueDashboardSlice.actions;

export default ResidueDashboardSlice.reducer;